/* WoodBuzz Kitchen Landing — GSAP, Lenis, and Interactions */
(function () {
  "use strict";

  /* ---------- NAV / MOBILE MENU ---------- */
  const nav = document.getElementById("nav");
  const sticky = document.getElementById("stickyCta");
  const onScroll = () => {
    if (nav) nav.classList.toggle("scrolled", window.scrollY > 40);
    if (sticky) {
      const show = window.scrollY > window.innerHeight * 0.7;
      sticky.classList.toggle("translate-y-28", !show);
      sticky.classList.toggle("opacity-0", !show);
      sticky.classList.toggle("pointer-events-none", !show);
    }
  };
  window.addEventListener("scroll", onScroll);
  onScroll();

  const mm = document.getElementById("mobileMenu");
  const menuBtn = document.getElementById("menuBtn");
  const menuClose = document.getElementById("menuClose");
  if (menuBtn && mm) {
    menuBtn.addEventListener("click", () => mm.classList.remove("translate-x-full"));
  }
  if (menuClose && mm) {
    menuClose.addEventListener("click", () => mm.classList.add("translate-x-full"));
  }
  if (mm) {
    mm.querySelectorAll("a").forEach((a) => {
      a.addEventListener("click", () => mm.classList.add("translate-x-full"));
    });
  }

  /* ---------- FAQ ACCORDION ---------- */
  document.querySelectorAll(".faq-item").forEach((item) => {
    const btn = item.querySelector("button");
    const body = item.querySelector(".faq-body");
    const icon = item.querySelector("i");
    if (btn && body) {
      btn.addEventListener("click", () => {
        const open = body.style.maxHeight && body.style.maxHeight !== "0px";
        document.querySelectorAll(".faq-item .faq-body").forEach((b) => (b.style.maxHeight = "0px"));
        document.querySelectorAll(".faq-item i").forEach((i) => (i.style.transform = "rotate(0deg)"));
        if (!open) {
          body.style.maxHeight = body.scrollHeight + "px";
          if (icon) icon.style.transform = "rotate(45deg)";
        }
      });
    }
  });

  /* ---------- PORTFOLIO FILTERS ---------- */
  document.querySelectorAll("#filterBar button").forEach((b) => {
    b.addEventListener("click", () => {
      document.querySelectorAll("#filterBar button").forEach((x) => {
        x.classList.remove("active");
      });
      b.classList.add("active");
      const filter = b.getAttribute("data-filter");
      document.querySelectorAll("#galleryGrid [data-cat]").forEach((card) => {
        const show = filter === "All" || card.getAttribute("data-cat") === filter;
        card.style.display = show ? "" : "none";
      });
    });
  });

  /* ---------- BEFORE / AFTER SLIDER ---------- */
  const ba = document.getElementById("baSlider");
  if (ba) {
    const after = document.getElementById("baAfter");
    const handle = document.getElementById("baHandle");
    let dragging = false;
    const setPos = (clientX) => {
      const r = ba.getBoundingClientRect();
      let p = ((clientX - r.left) / r.width) * 100;
      p = Math.max(4, Math.min(96, p));
      if (after) after.style.clipPath = `inset(0 0 0 ${p}%)`;
      if (handle) handle.style.left = p + "%";
    };
    const start = () => (dragging = true);
    const end = () => (dragging = false);
    const move = (e) => {
      if (!dragging) return;
      setPos(e.touches ? e.touches[0].clientX : e.clientX);
    };
    ba.addEventListener("mousedown", (e) => {
      start();
      setPos(e.clientX);
    });
    ba.addEventListener("touchstart", (e) => {
      start();
      setPos(e.touches[0].clientX);
    }, { passive: true });
    window.addEventListener("mousemove", move);
    window.addEventListener("touchmove", move, { passive: true });
    window.addEventListener("mouseup", end);
    window.addEventListener("touchend", end);
  }

  /* ---------- CUSTOM CURSOR ---------- */
  const dot = document.getElementById("cursorDot");
  const ring = document.getElementById("cursorRing");
  if (dot && ring && window.matchMedia("(hover:hover)").matches) {
    let rx = 0, ry = 0, dx = 0, dy = 0;
    let isHovered = false;
    window.addEventListener("mousemove", (e) => {
      dx = e.clientX;
      dy = e.clientY;
      dot.style.transform = `translate(${dx}px, ${dy}px) translate(-50%,-50%)`;
    });
    const loop = () => {
      rx += (dx - rx) * 0.18;
      ry += (dy - ry) * 0.18;
      const scale = isHovered ? " scale(1.35)" : "";
      ring.style.transform = `translate(${rx}px, ${ry}px) translate(-50%,-50%)${scale}`;
      requestAnimationFrame(loop);
    };
    loop();
    document.addEventListener("mouseover", (e) => {
      if (e.target.closest("[data-cursor], a, button, input, select")) {
        isHovered = true;
        ring.style.borderColor = "rgba(31,91,62,.7)";
      }
    });
    document.addEventListener("mouseout", (e) => {
      if (e.target.closest("[data-cursor], a, button, input, select")) {
        isHovered = false;
        ring.style.borderColor = "rgba(184,115,51,.6)";
      }
    });
  }

  /* ---------- CONSULTATION MODAL ---------- */
  const modal = document.getElementById("consultModal");
  const modalOverlay = document.getElementById("modalOverlay");
  const modalCard = document.getElementById("modalCard");
  const openModal = () => {
    if (!modal) return;
    const mmenu = document.getElementById("mobileMenu");
    if (mmenu) mmenu.classList.add("translate-x-full");
    modal.classList.remove("hidden");
    document.body.style.overflow = "hidden";
    requestAnimationFrame(() => {
      if (modalOverlay) modalOverlay.style.opacity = "1";
      if (modalCard) {
        modalCard.style.opacity = "1";
        modalCard.style.transform = "scale(1)";
      }
    });
    const first = modal.querySelector("input[name='name']");
    if (first) setTimeout(() => first.focus(), 380);
  };
  const closeModal = () => {
    if (!modal) return;
    if (modalOverlay) modalOverlay.style.opacity = "0";
    if (modalCard) {
      modalCard.style.opacity = "0";
      modalCard.style.transform = "scale(0.95)";
    }
    document.body.style.overflow = "";
    setTimeout(() => modal.classList.add("hidden"), 340);
  };
  document.querySelectorAll("[data-open-modal]").forEach((b) => {
    b.addEventListener("click", (e) => {
      e.preventDefault();
      openModal();
    });
  });
  const mClose = document.getElementById("modalClose");
  if (mClose) mClose.addEventListener("click", closeModal);
  if (modalOverlay) modalOverlay.addEventListener("click", closeModal);
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && modal && !modal.classList.contains("hidden")) {
      closeModal();
    }
  });

  /* ---------- GSAP ANIMATIONS ---------- */
  if (window.gsap) {
    gsap.registerPlugin(window.ScrollTrigger);

    // Hero on-load reveal
    const tl = gsap.timeline({ delay: 0.25 });
    tl.to(".line-inner", { y: "0%", duration: 1.1, stagger: 0.12, ease: "power4.out" })
      .to(".hero-fade", { opacity: 1, y: 0, duration: 0.8, stagger: 0.12, ease: "power2.out" }, "-=0.7")
      .fromTo("#heroCard", { opacity: 0, y: 40 }, { opacity: 1, y: 0, duration: 0.9, ease: "power3.out" }, "-=0.9");

    // Hero parallax
    gsap.to(".hero-parallax", {
      yPercent: 12,
      ease: "none",
      scrollTrigger: {
        trigger: "#top",
        start: "top top",
        end: "bottom top",
        scrub: true
      }
    });
  } else {
    document.querySelectorAll(".line-inner").forEach((n) => (n.style.transform = "none"));
    document.querySelectorAll(".hero-fade, #heroCard").forEach((n) => (n.style.opacity = "1"));
  }

  /* ---------- SCROLL REVEALS (IntersectionObserver) ---------- */
  const revealEls = document.querySelectorAll("[data-reveal]");
  if ("IntersectionObserver" in window) {
    const io = new IntersectionObserver((entries, obs) => {
      entries.forEach((e) => {
        if (e.isIntersecting) {
          const t = e.target;
          const sibs = Array.from(t.parentElement ? t.parentElement.children : [t]).filter((c) => c.hasAttribute("data-reveal"));
          const idx = Math.max(0, sibs.indexOf(t));
          t.style.transitionDelay = Math.min(idx * 70, 350) + "ms";
          t.classList.add("is-in");
          obs.unobserve(t);
        }
      });
    }, { threshold: 0.12, rootMargin: "0px 0px -8% 0px" });
    revealEls.forEach((n) => io.observe(n));
  } else {
    revealEls.forEach((n) => n.classList.add("is-in"));
  }
})();
